module.exports = __webpack_public_path__ + "img/logo.84e01b04.svg";